import React, { useEffect, useState } from 'react';

const SPLASH_MIN_DURATION = 1600; // ms — long enough to feel intentional, short enough to not annoy
const FADE_DURATION = 500;
const SESSION_FLAG = 'hussar_splash_shown';

const SplashScreen = ({ children }) => {
  const [phase, setPhase] = useState(() => {
    try {
      return sessionStorage.getItem(SESSION_FLAG) === '1' ? 'done' : 'showing';
    } catch {
      return 'showing';
    }
  });

  useEffect(() => {
    if (phase !== 'showing') return;
    const fadeTimer = setTimeout(() => setPhase('fading'), SPLASH_MIN_DURATION);
    return () => clearTimeout(fadeTimer);
  }, [phase]);

  useEffect(() => {
    if (phase !== 'fading') return;
    const removeTimer = setTimeout(() => {
      setPhase('done');
      try {
        sessionStorage.setItem(SESSION_FLAG, '1');
      } catch {
        // sessionStorage unavailable — ignore
      }
    }, FADE_DURATION);
    return () => clearTimeout(removeTimer);
  }, [phase]);

  const visible = phase !== 'done';
  const fadingOut = phase === 'fading';

  return (
    <>
      {visible && (
        <div
          className={`hussar-splash ${fadingOut ? 'hussar-splash-fade' : ''}`}
          data-testid="splash-screen"
          aria-hidden={fadingOut}
        >
          <div className="hussar-splash-inner">
            <div className="hussar-splash-motto" data-testid="splash-motto">
              AI przygotowuje. Człowiek decyduje.
            </div>
            <img
              src="/hussarai-logo-full.png"
              alt="HussarAi"
              className="hussar-splash-logo"
            />
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export default SplashScreen;
